import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text, Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const NoReturnNotification = () => {
    const styles = useMultiStyleConfig('Cart')

    return (
        <Box {...styles.cartNoReturnWrapper}>
            <Text {...styles.cartNoReturnText}>
                <FormattedMessage
                    defaultMessage="* No returns or exchanges"
                    id="cart_notification.no_return_notification"
                />
            </Text>
        </Box>
    )
}

export default NoReturnNotification
